import { Controller } from "@hotwired/stimulus";

// Native dialog provides focus trapping and background inertness. This
// controller positions it as a right drawer, restores the opener's focus, and
// prevents the page behind the scrim from scrolling.
export default class extends Controller {
  static targets = ["overlay", "panel"];

  connect() {
    this.opener = document.activeElement;
    this.previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    if (!this.element.open) this.element.showModal();
    requestAnimationFrame(() => {
      this.element.dataset.state = "open";
    });
  }

  disconnect() {
    window.clearTimeout(this.closeTimer);
    document.body.style.overflow = this.previousOverflow;
    this.restoreFocus();
  }

  close() {
    if (!this.element.open || this.element.dataset.state === "closing") return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.element.close();
      return;
    }

    this.element.dataset.state = "closing";
    this.closeTimer = window.setTimeout(() => this.element.close(), 180);
  }

  cancel(event) {
    event.preventDefault();
    this.close();
  }

  closed() {
    this.element.dataset.state = "closed";
    document.body.style.overflow = this.previousOverflow;
    this.restoreFocus();
  }

  restoreFocus() {
    if (this.opener?.isConnected) this.opener.focus();
  }
}
